// ダウンロード CSV 共通のメタ情報・日付整形ユーティリティ。
// R/L 両ツールの CSV ダウンロードで再利用する（重複排除）。

const pad = (value: number): string => value.toString().padStart(2, "0");

/** ファイル名向けタイムスタンプ（YYYYMMDD_HHMMSS）。 */
export const formatFileTimestamp = (date: Date): string =>
    `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}_${pad(date.getHours())}${pad(date.getMinutes())}${pad(date.getSeconds())}`;

/** CSV 本文表示向けのダウンロード日時（YYYY/MM/DD HH:MM:SS）。 */
export const formatDownloadDate = (date: Date): string =>
    `${date.getFullYear()}/${pad(date.getMonth() + 1)}/${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;

/** CSV セルのエスケープ。カンマ・改行・ダブルクオートを含む場合のみ "" で囲む。 */
const escapeCsvCell = (value: string): string =>
    /[",\r\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;

export type CsvMetadataInput = {
    calcSetName: string;
    date: Date;
};

/**
 * CSV 冒頭へ付与するメタ情報行を返す。
 * 「計算セット名」「ダウンロード日時」の2行に続き、データ表との区切りの空行を入れる。
 * 返り値はそのまま本文行配列の先頭へ連結する想定。
 */
export const buildCsvMetadataLines = ({ calcSetName, date }: CsvMetadataInput): string[] => [
    `計算セット名,${escapeCsvCell(calcSetName)}`,
    `ダウンロード日時,${escapeCsvCell(formatDownloadDate(date))}`,
    "",
];

// UTF-8 BOM。Excel はローカル CSV を開くとき MIME の charset を無視し、
// BOM が無いと既定コードページ（日本語環境では Shift-JIS）で解釈するため、
// 日本語を含むメタ情報が文字化けする。BOM を先頭に付けて UTF-8 と認識させる。
const UTF8_BOM = String.fromCharCode(0xfeff);

/**
 * CSV 文字列から UTF-8 BOM 付きの Blob を生成する。
 * 日本語メタ情報の文字化け防止のため、CSV ダウンロードはこのヘルパー経由で行う。
 */
export const buildCsvBlob = (csvContent: string): Blob =>
    new Blob([UTF8_BOM + csvContent], { type: "text/csv;charset=utf-8;" });
